import { Button, Header, Modal, SearchSelect, Text } from '@bbl-digital/snorre'
import { FCWithChildren } from 'global'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PageLoader from 'shared/components/PageLoader'
import useCheckParamsForClient from 'shared/hooks/useCheckParamsForClient'
import useCheckParamsForRelationPicker from 'shared/hooks/useCheckParamsForRelationPicker'
import { SimpleClient } from 'shared/models/Client'
import { getBblDisplayNames } from 'shared/store/bbl'
import { setClientById } from 'shared/store/clients/actions'
import {
  clientApiSelector,
  getActiveClient,
  getActiveClientId,
  getClients,
  getIsSettingClient,
} from 'shared/store/clients/selectors'
import { getUser } from 'shared/store/user/selectors'
import { SelectWrapper, Wrapper } from './styles'

const RelationPicker: FCWithChildren = ({ children }) => {
  const dispatch = useDispatch()
  const redirectIfFaultyClient = useCheckParamsForClient()
  const resetRelationPickerIfRelationPickerParam =
    useCheckParamsForRelationPicker()

  const client = useSelector(getActiveClient)
  const clients = useSelector(getClients)
  const isSettingClient = useSelector(getIsSettingClient)
  const { data: user, isLoading: isUserLoading } = useSelector(getUser)
  const { portalShort } = useSelector(getBblDisplayNames)

  const currentClientId = useSelector(getActiveClientId)
  const { isLoading: isClientLoading } = useSelector(
    clientApiSelector(currentClientId)
  )

  const [selectedClient, setSelectedClient] = useState<SimpleClient>()
  const loading = isClientLoading || isUserLoading

  useEffect(() => {
    if (clients?.length) {
      const [firstClient] = clients
      setSelectedClient(firstClient)
    }
  }, [clients])

  const handleSelectItem = (c: SimpleClient) => setSelectedClient(c)

  const notBoardMember =
    user && !user.roles.some((x) => x.role === 'StyreportalBruker')

  const Picker = (
    <Modal
      open
      header={<Header level={2}>Hei, {user?.firstname}</Header>}
      disableOutsideClick
      hideCloseButton
      disableScrollableContent
    >
      <Wrapper>
        <Text bold>
          Vennligst velg hvilket selskap du ønsker å logge inn med.
        </Text>

        <SelectWrapper>
          <Text bold>{portalShort}</Text>

          {clients && clients.length > 0 && (
            <SearchSelect
              selectedValue={selectedClient?.name}
              createLabelName={(item) => {
                const typedItem = item as unknown as SimpleClient
                return `${typedItem.no} - ${typedItem.name}`
              }}
              fuzzyKeys={['sortKey', 'no', 'name']}
              values={clients as []}
              onChange={(item) =>
                handleSelectItem(item as unknown as SimpleClient)
              }
              placeholder={selectedClient?.name ?? 'Velg selskap'}
              inputPlaceholder="Søk etter selskap"
            />
          )}
        </SelectWrapper>

        <Button
          disabled={!selectedClient}
          highlight
          // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
          onClick={() => dispatch(setClientById(selectedClient?.id!))}
          loading={isSettingClient}
        >
          Bekreft
        </Button>
      </Wrapper>
    </Modal>
  )

  if (loading) return <PageLoader />

  if (clients?.length) {
    if (clients.length > 1) resetRelationPickerIfRelationPickerParam() // Show relation picker if param rpp is set and multiple clients, used for redirect from old portal

    redirectIfFaultyClient(client) // Automatic set client if clientId is set in param

    if (client)
      return (
        <>
          {isSettingClient && <PageLoader overlay />}
          {children}
        </>
      )
    return Picker
  }

  if (user && notBoardMember) return <>{children}</>

  return null
}

export default RelationPicker
